<div class="out">
  <img class="next" src="assets/images/expand_l.svg"  kzLib (click)="prev()" [ngClass]="{disabled:value<1}">
  <div class="abs_center br_bt"> {{value}}</div>
  <img class="next prev" src="assets/images/expand_l.svg"  kzLib (click)="next()" [ngClass]="{disabled:value>=max}">
</div>